import {View} from 'native-base';
import React from 'react';

import FilterBarAccordion from 'components/FilterBarAccordion';
import {AdobeEvent, useTrackEvent} from 'hooks/useTrackEvent';
import {OfferFiltersDestination} from 'models/OfferFilters';

import OfferFilter from '../Filter';
import OfferFilterList from '../List';

export interface OfferFilterDestinationProps {
  list?: OfferFiltersDestination[];
  selected?: OfferFiltersDestination;
  onSelect?: (item: OfferFiltersDestination) => void;
  toggle?: boolean;
  onToggle?: () => void;
  availableProperties?: string[];
  offersCount: {[key: string]: number};
}

const OfferFilterDestination: React.FC<OfferFilterDestinationProps> = props => {
  const {trackAdobeEvent} = useTrackEvent();
  const {
    list = [],
    selected,
    onSelect,
    toggle,
    onToggle,
    availableProperties,
    offersCount,
  } = props;
  const handleSelect = item => () => {
    onSelect && onSelect(item);
    trackAdobeEvent({
      event: AdobeEvent.click,
      click: {name: 'rewards filter'},
      rewards: {category: 'DESTINATIONS', filter: item.name},
    });
  };

  const isSelected = item => selected?.id === item.id;

  const totalCount = Object.values(offersCount).reduce(
    (sum: number, cur: number) => sum + cur,
    0
  );

  return (
    <View width="100%">
      <FilterBarAccordion
        toggle={toggle}
        accordionTop={
          <OfferFilter
            title="Destinations"
            icon="map-marker-alt"
            altText={selected?.name}
            count={selected ? offersCount[selected.id] : totalCount}
            isOpen={toggle}
            onToggle={onToggle}
          />
        }
        accordionBody={
          <OfferFilterList
            list={list}
            onSelect={handleSelect}
            isSelected={isSelected}
            offersCount={offersCount}
            availableProperties={availableProperties}
          />
        }
      />
    </View>
  );
};

export default OfferFilterDestination;
